export async function sha256File(file) {
  const buf = await file.arrayBuffer();
  return digestHex(buf);
}

export async function sha256Text(text) {
  return digestHex(new TextEncoder().encode(text));
}

async function digestHex(data) {
  const hash = await window.crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
